// BRK-S038 — the shared "verify every extracted value" primitives, generalizing
// the BRK-S055 carried-forward review pattern (per-field marker + a review
// banner) for document autopopulation. A prefilled step MARKS every field
// extraction filled and requires the broker to review it; EDITING a field clears
// its marker, and nothing auto-commits or auto-advances (the step's own submit
// button is the explicit confirmation). Reused across step 1, the AccountForm
// step, and the manifest details step so the marker reads identically
// everywhere. The state hook lives in @/lib/useExtractedReview.

/** The subtle per-field hint marking a value pulled from an uploaded document —
 *  the extraction analogue of the carried-forward marker (BRK-S055). */
export function ExtractedMarker() {
  return (
    <p className="text-xs text-brk-dim">
      <span aria-hidden="true">✨ </span>From your document — confirm or edit.
    </p>
  );
}

/** The one-shot review banner leading a step that extraction prefilled: names how
 *  many fields to check and makes the "review before continuing" ask explicit.
 *  Renders nothing once every field has been touched (pendingCount hits 0). */
export function ExtractedReviewBanner({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <div
      role="status"
      className="flex flex-col gap-1 rounded-md border border-brk-accent/40 bg-brk-bg px-3 py-2 text-sm text-brk-dim"
    >
      <span className="font-medium text-brk-text">
        We filled {count} {count === 1 ? "field" : "fields"} from your document.
      </span>
      <span>
        Review each one — confirm it or edit it — then continue. Nothing is
        saved until you do.
      </span>
    </div>
  );
}
